import { lazy, Suspense } from "react";

const Impl = lazy(() => import("./RichEditorImpl"));
export const preloadRichEditor = () => import("./RichEditorImpl");

export default function RichEditor(props) {
  const h = (props.minHeight || 96) + (props.toolbar === "focus" ? 0 : 42);
  return (
    <Suspense fallback={<div className={`rounded-xl bg-muted/40 ${props.className || ""}`} style={{ minHeight: h }} data-testid={`${props.testid || "rich"}-loading`} />}>
      <Impl {...props} />
    </Suspense>
  );
}
